import { LocationEntity } from './location.entity';

/**
 * Return a list of entities that are the child of the provided entity
 */
export function getChildLocations(
  locations?: LocationEntity[],
  searchLocationId?: string
): LocationEntity[] {
  if (!locations || !searchLocationId) return [];

  return _getChildLocations(locations, searchLocationId, new Set());
}

export function _getChildLocations(
  locations: LocationEntity[],
  searchLocationId: string,
  acc: Set<string>
): LocationEntity[] {
  const foundIds = locations.reduce<Set<string>>((acc: Set<string>, loc) => {
    if (loc.parentId == searchLocationId && !acc.has(loc.id)) {
      acc.add(loc.id);

      _getChildLocations(locations, loc.id, acc).forEach((loc) =>
        acc.add(loc.id)
      );
    }
    return acc;
  }, acc);

  return locations.filter((loc) => foundIds.has(loc.id));
}